<script>
import useSharedData from "@/use/SharedData.js";
import {usePaySectionStore} from "@/stores/PaySection.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {computed, onMounted, ref, watch} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import PaiePreview from "@/views/Worker/Components/PaiePreview.vue";

export default {
    name: 'PaySectionSelection',
    components: {PaiePreview},
    props: {
        initialPaySectionSelection: Array,
        byOccupation: Boolean,
        payPreview: Boolean,
        workerId: [Number, String],
        readonly: Boolean,
        importPaySectionsLoading: Boolean,
    },
    setup(props, {emit}) {
        const {dialog, loading, inputColor, backgroundColor} = useSharedData();
        const {paySectionPositions} = useSharedSelectData();
        const {getPaySectionPosition, priceFormat} = useSharedMethod();
        const paySectionSelectDialog = ref(false);
        const selected = ref([]);
        const tab = ref(0);
        const ordre = ref(0);
        
        const paySectionSelection = ref([]);
        
        const paySectionStore = usePaySectionStore();
        
        function getRemoveIndex(code) {
            return paySectionSelection.value.map((item) => item.paySectionCode).indexOf(code);
        }
        
        function removeByIndex(paySection) {
            const ps = paySectionStore.paySections.find((p) => p.code === paySection.paySectionCode);
            let removeIndex = getRemoveIndex(paySection.paySectionCode);
            paySectionSelection.value.splice(removeIndex, 1);
            ps.relations.forEach((relation) => {
                if (relation.manualDelete) {
                    removeIndex = getRemoveIndex(relation.code);
                    if (removeIndex !== -1) {
                        paySectionSelection.value.splice(removeIndex, 1);
                    }
                }
            });
        }
        
        function setPaySections() {
            const temp = paySectionSelection.value;
            selected.value.forEach((element) => {
                const exist = temp.find((e) => e.paySectionCode === element.code);
                let value = 0;
                if (exist) {
                    value = exist.value;
                }
                
                paySectionSelection.value.push({
                    paySectionId: element.id,
                    paySectionCode: element.code,
                    paySectionName: element.label,
                    paySectionOrder: element.order,
                    paySectionFormula: element.formula,
                    value: value, // element.value,
                    result: element.result,
                    ordre: ordre.value,
                    calculated: !!(element.formule && (element.value === 0 || !element.value)),
                    position: element.position ? element.position : getPaySectionPosition(tab.value),
                    byOccupation: props.byOccupation
                });
            });
            selected.value = [];
            paySectionSelection.value.sort((a, b) => a.ordre > b.ordre ? 1 : b.ordre > a.ordre ? -1 : 0);
            paySectionSelectDialog.value = false;
        }
        
        function closeDialog() {
            paySectionSelectDialog.value = false;
        }
        
        function showValue(item) {
            if (item.paySectionFormula && item.value === 0) {
                return item.paySectionFormula;
            } else {
                return item.value
            }
        }
        
        function setOrdre() {
            const inputData = paySectionSelection.value.filter(paySection => paySection.position === getPaySectionPosition(tab.value));
            let obj = inputData.reduce((maxObject, currentObject) => {
                return currentObject.ordre > maxObject.ordre ? currentObject : maxObject;
            }, inputData[0]);
            ordre.value = obj ? obj.ordre + 1 : 0;
        }
        
        function setSpecificOrdre(index) {
            ordre.value = index;
        }
        
        function getItems(items) {
            let result = [];
            let i = 0;
            while (i < 20 && result.length <= 20) {
                const filterResult = items.filter(item => item.ordre === i);
                if (filterResult.length > 0) {
                    filterResult.forEach(item => {
                        result.push(item);
                    });
                } else {
                    result.push({name: 'empty', order: i});
                }
                i++;
            }
            return result;
        }
        
        function shiftForwardAndBackward(position, line, forward) {
            paySectionSelection.value.forEach(element => {
                if (element.position === position && element.ordre > line) {
                    if (forward) {
                        element.ordre += 1;
                    } else {
                        element.ordre -= 1;
                    }
                }
            });
        }
        
        const fix = computed(() => {
            const items = paySectionSelection.value.filter(paySection => paySection.position === 'FIX').sort((a, b) => a.ordre - b.ordre);
            return getItems(items);
        });
        
        const variable = computed(() => {
            const items = paySectionSelection.value.filter(paySection => paySection.position === 'VARIABLE').sort((a, b) => a.ordre - b.ordre);
            return getItems(items);
        });
        
        const result = computed(() => {
            return paySectionSelection.value.filter(paySection => paySection.position === 'RESULT').sort((a, b) => a.paySectionOrder - b.paySectionOrder);
        });
        
        function addPaySectionsWhenSelectOrdre(index) {
            ordre.value = index;
            paySectionSelectDialog.value = true;
        }
        
        function addPaySectionsWithoutSelectOrdre() {
            setOrdre();
            paySectionSelectDialog.value = true;
        }
        
        function upOrder() {
        
        }
        
        function downOrder() {
            // const ps = paySectionSelection.value.filter(e => e.ordre === ordre);
        }
        
        onMounted(() => {
            if (paySectionStore.paySections.length === 0)
                paySectionStore.findAll();
            paySectionSelection.value = props.initialPaySectionSelection;
        });
        
        watch(() => paySectionSelection.value, () => {
            emit('updatePaySection', paySectionSelection.value);
        }, {deep: true, immediate: false});
        
        return {
            dialog,
            loading,
            inputColor,
            backgroundColor,
            paySectionSelectDialog,
            selected,
            tab,
            ordre,
            paySectionSelection,
            paySectionPositions,
            fix,
            variable,
            result,
            removeByIndex,
            setPaySections,
            closeDialog,
            showValue,
            priceFormat,
            getItems,
            setSpecificOrdre,
            addPaySectionsWhenSelectOrdre,
            addPaySectionsWithoutSelectOrdre,
            shiftForwardAndBackward,
            upOrder,
            downOrder
        }
    }
};
</script>

<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-tabs
                    v-model="tab"
                    fixed-tabs
                    :background-color="backgroundColor"
                    dense
                    color="teal"
                    height="35"
                >
                    <v-tab
                        v-for="t in ['FIX', 'VARIABLE']"
                        :key="t">
                        {{ $t(`common.${t}`) }}
                    </v-tab>
                    <v-tab>
                        {{ $t(`common.RESULT`) }}
                    </v-tab>
                    <v-tab v-if="payPreview" @click="$refs.childComponent.preview()">
                        Bulletin
                    </v-tab>
                    
                    <v-tab-item
                        eager
                        v-for="t in ['FIX', 'VARIABLE']"
                        :key="t">
                        
                        <v-container fluid>
                            <v-simple-table dense fixed-header height="400">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left" style="width: 0;"></th>
                                        <th class="text-left" style="width: 0;">{{ $t('common.code') }}</th>
                                        <th class="text-left">{{ $t('common.label') }}</th>
                                        <th class="text-left">{{ $t('common.value') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template
                                        v-for="(item, index) in  t === 'FIX' ? fix: variable"
                                    >
                                        <tr
                                            class="emptytr"
                                            :key="`empty-fix-${index}`"
                                            @dblclick="addPaySectionsWhenSelectOrdre(item.order)"
                                            v-if="item.name === 'empty'"
                                        >
                                            <td style="width: 0;">
                                                <v-menu
                                                    :disabled="readonly"
                                                    offset-y
                                                    right
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            icon
                                                            class="ml-n3 mr-n3"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon color="blue">mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list dense>
                                                        <v-list-item
                                                            @click="shiftForwardAndBackward(t, index, true)"
                                                        >
                                                            <v-list-item-icon>
                                                                <v-icon color="blue darken-2">mdi-table-split-cell</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-title>{{ $t('common.add_element') }}</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click="shiftForwardAndBackward(t, index, false)"
                                                        >
                                                            <v-list-item-icon>
                                                                <v-icon color="red">mdi-trash-can</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-title>{{ $t('common.remove_element') }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </td>
                                            <td style="width: 0;">
                                                <input-pay-section-component
                                                    v-if="!readonly"
                                                    :selected="selected"
                                                    @save="setPaySections"
                                                    @selecteOrdre="setSpecificOrdre(item.order)"
                                                />
                                            </td>
                                            <td colspan="2"></td>
                                        </tr>
                                        <tr
                                            :key="`full-${t}-${index}`"
                                            :style="!item.byOccupation ? 'background-color: #BBDEFB' : null"
                                            v-else
                                        >
                                            <td style="width: 0;">
                                                <v-menu
                                                    :disabled="readonly"
                                                    offset-y
                                                    right
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            icon
                                                            class="ml-n3 mr-n3"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon color="blue">mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list dense>
                                                        <v-list-item
                                                            @click="shiftForwardAndBackward(t, index, true)"
                                                        >
                                                            <v-list-item-icon>
                                                                <v-icon color="blue darken-2">mdi-table-split-cell
                                                                </v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-title>{{ $t('common.add_element') }}</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click="removeByIndex(item)"
                                                        >
                                                            <v-list-item-icon>
                                                                <v-icon color="red">mdi-trash-can</v-icon>
                                                            </v-list-item-icon>
                                                            <v-list-item-title>{{ $t('common.remove_element') }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </td>
                                            <td style="width: 0;">
                                                <v-tooltip
                                                    right
                                                    :disabled="!paySectionFormula"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        {{ item.paySectionCode }}
                                                    </span>
                                                    </template>
                                                    <span>{{ item.paySectionFormula }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td>{{ item.paySectionName }}</td>
                                            <td>
                                                <w-edit-dialog
                                                    v-model="item.value"
                                                    price-format
                                                    hide-chip
                                                    hide-details
                                                    :readonly="readonly"
                                                />
                                            </td>
                                        </tr>
                                    </template>
                                    
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item eager>
                        <v-container fluid>
                            <v-simple-table dense fixed-header height="400">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left" style="width: 0;">{{ $t('common.code') }}</th>
                                        <th class="text-left">{{ $t('common.name') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template
                                        v-for="(item, index) in result"
                                    >
                                        <tr
                                            :key="`full-RESULT-${index}`"
                                        >
                                            
                                            <td v-if="item.paySectionFormula" style="width: 0;">
                                                <v-tooltip right>
                                                    <template v-slot:activator="{ on, attrs }">
                                                    <span v-bind="attrs" v-on="on">
                                                        {{ item.paySectionCode }}
                                                    </span>
                                                    </template>
                                                    <span>{{ item.paySectionFormula }}</span>
                                                </v-tooltip>
                                            </td>
                                            <td v-else style="width: 0;">
                                                {{ item.paySectionCode }}
                                            </td>
                                            <td>{{ item.paySectionName }}</td>
                                        </tr>
                                    </template>
                                    
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item v-if="payPreview" eager>
                        <paie-preview ref="childComponent"/>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <select-pay-section-component
                :dialog="paySectionSelectDialog"
                :selected="selected"
                @save="setPaySections"
                @close="closeDialog"
            ></select-pay-section-component>
        </v-card>
    </div>
</template>

<style>

.emptytr {
    cursor: default;
    background-color: #FFE0B2;
}

.emptytr:hover {
    cursor: pointer;
}
</style>